export default __webpack_public_path__ + "static/media/logo_white.f4507997.png";